const baseUrl = process.env.BASE_URL;
const baseUrlServer = process.env.BASE_URL_SERVER;

export default function fetchUrl(apiService, postFixUrl) {
  let hostUrl = baseUrl;
  if (!process.browser) {
    if (baseUrlServer) {
      hostUrl = baseUrlServer;
    }
    console.log(`/${apiService}/${postFixUrl}`, "called from ", hostUrl);
  }
  return `${hostUrl}/${apiService}/${postFixUrl}`;
}
